<template>
  <div class="reserve-seat-view">
    <div class="dateNavWrap">
      <button @click="prevDay" class="dateNav monthNav">◀</button>
      <input
        type="date"
        v-model="selectedDate"
        @change="fetchReservations"
        class="dateInput"
        :min="minDate"
        :max="maxDate"
      />
      <button @click="nextDay" class="dateNav monthNav">▶</button>
      <div class="monthNavWrap"></div>
    </div>
    <div class="summaryData" style="margin: 1rem 0 0">
      <div>
        <p>Remaining seats</p>
        <p>{{ availableSeatsCount }} / {{ seats.length }}</p>
      </div>
    </div>

    <div class="roomsFlex">
        <!-- Room 4.07 -->
        <div class="roomBox">
            <h3 class="roomTitle">4.07</h3>
            <div class="seatWrap seatGrid" :style="{ '--cols': 16, '--rows': 22 }">
                <div :style="seatGridStyle('Meeting')" class="seat">
                    <a href="/attendance/hubroom" class="hubRoomLink"><span style="color: var(--blue);">Hub Room</span></a></div>
                <div
                v-for="seat in seats407"
                :key="'407-' + seat.id"
                class="seat"
                :style="seatGridStyle(seat)"
                :class="{
                    reserved: seat.reserved,
                    reservedByYou: seat.reserved && seat.reservation && seat.reservation.user === currentUserId,
                    'past-date': isPastDate(selectedDate),
                }"
                @click="handleSeatClick(seat)"
                >
                    <span v-if="seat.reserved" v-html="seat.reservedBy"></span>
                    <span v-else>{{ seat.id }}</span>
                </div>
            </div>
        </div>
        <!-- Room 3.05 -->
        <div class="roomBox t305">
            <h3 class="roomTitle">3.05</h3>
            <div class="seatWrap seatGrid" :style="{ '--cols': 10, '--rows': 16 }">
                <div
                v-for="seat in seats305"
                :key="'305-' + seat.id"
                class="seat"
                :style="seatGridStyle(seat)"
                :class="{
                    reserved: seat.reserved,
                    reservedByYou: seat.reserved && seat.reservation && seat.reservation.user === currentUserId,
                    'past-date': isPastDate(selectedDate),
                }"
                @click="handleSeatClick(seat)"
                >
                <span v-if="seat.reserved" v-html="seat.reservedBy"></span>
                <span v-else>{{ seat.id }}</span>
            </div>
        </div>
    </div>
</div>

    <ReservationModal
      v-if="selectedSeat"
      :visible="showModal"
      :seat="selectedSeat"
      :initialDate="selectedDate"
      @close="closeModal"
      @confirmed="afterConfirm"
    />
    <CancelSeatModal
      :visible="showCancelModal"
      :reservationId="cancelReservationId"
      @close="showCancelModal = false"
      @confirmed="onCancelConfirmed"
    />
  </div>
</template>

<script>
import ReservationModal from "@/components/ReservationModal.vue";
import api, {
  setAuthToken,
  fetchSeatLabels as apiFetchSeatLabels,
  fetchUsers,
} from "@/services/api";
import CancelSeatModal from "@/components/CancelSeatModal.vue";

export default {
    name: "DeskReservationView",
    components: {
        ReservationModal,
        CancelSeatModal,
    },
    data() {
        return {
            selectedDate: this.$now().toISOString().substr(0, 10),
            seats: [],
            seatLabels: [],
            users: [],
            showModal: false,
            showCancelModal: false,
            cancelReservationId: null,
            selectedSeat: null,
            seatGridMap407: {
                Meeting: { c: 1,  r: 9, w: 6, h: 6 },
                A: { c: 1,  r: 20, w: 4, h: 2 },
                B: { c: 1,  r: 18, w: 4, h: 2 },
                C: { c: 11, r: 19,  w: 3, h: 4 },
                D: { c: 11, r: 15,  w: 3, h: 4 },
                F: { c: 14, r: 19,  w: 3, h: 4 },
                G: { c: 14, r: 15,  w: 3, h: 4 },
                E: { c: 11, r: 10,  w: 3, h: 4 },
                H: { c: 14, r: 10,  w: 3, h: 4 },
                I: { c: 14, r: 6,  w: 3, h: 4 },
                M: { c: 11, r: 6,  w: 3, h: 4 },
                J: { c: 14, r: 1,  w: 3, h: 4 },
                K: { c: 4,  r: 3,  w: 4, h: 2 },
                L: { c: 1,  r: 1,  w: 3, h: 4 },
            },
            seatGridMap305: {
                T: { c: 6,  r: 7,  w: 3, h: 2 },
                U: { c: 6,  r: 5, w: 3, h: 2 },
                V: { c: 6,  r: 3,  w: 3, h: 2 },
                W: { c: 3,  r: 7, w: 3, h: 2 },
                X: { c: 3,  r: 5, w: 3, h: 2 },
                Y: { c: 3,  r: 3,  w: 3, h: 2 },
                Z: { c: 3,  r:1,  w: 6, h: 2 },
            },
        };
    },
    computed: {
        currentUserId() {
            if (typeof localStorage !== 'undefined') {
                return Number(localStorage.getItem('userId'));
            }
            return null;
        },
        availableSeatsCount() {
            return this.seats.filter((seat) => !seat.reserved).length;
        },
        formattedDate() {
// 英語月＋日＋年の形式で表示
            const date = new Date(this.selectedDate);
            const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            const month = monthNames[date.getMonth()];
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month} ${day}, ${year}`;
        },
        minDate() {
            const d = this.$now();
            d.setMonth(d.getMonth() - 3); // 3 months ago
            return d.toISOString().slice(0, 10);
        },
        maxDate() {
            const d = this.$now();
            d.setFullYear(d.getFullYear() + 1); // 1 year ahead
            return d.toISOString().slice(0, 10);
        },
        seats407() { return this.seats.filter(s => /^[A-M]$/.test(s.id)); },
        seats305() { return this.seats.filter(s => /^[T-Z]$/.test(s.id)); },
    },
    async mounted() {
        const token = sessionStorage.getItem("token");
        if (token) setAuthToken(token);
    // --- Read date from URL query and set to selectedDate here ---
        const dateFromQuery = this.$route.query.date;
        if (dateFromQuery) {
            this.selectedDate = dateFromQuery;
        } else {
    // If no query, default to "today"
            this.selectedDate = this.$now().toISOString().substr(0, 10);
        }
    // ------------------------------------------------------

        await this.fetchSeatLabels();
        await this.fetchUsers();
        await this.fetchReservations();
    },

    methods: {
        async fetchSeatLabels() {
            try {
                const resp = await apiFetchSeatLabels();
                this.seatLabels = resp.data.sort((a, b) =>
                    a.code.localeCompare(b.code)
                    );
            } catch (e) {
                console.error("Failed to fetch seat labels", e);
            }
        },
        async fetchUsers() {
            try {
                const res = await fetchUsers();
                this.users = res.data.users;
            } catch (e) {
                console.error("Failed to fetch user information:", e);
            }
        },
        async fetchReservations() {
            try {
                const res = await api.get(`/seats/reserve/?date=${this.selectedDate}`);
                const data = Array.isArray(res.data) ? res.data : res.data.reservations;
                this.seats = this.seatLabels.map((label) => {
                    const r = data.find((x) => x.seat_number === label.code);
                    let displayName = "";
                    if (r) {
                        if (r.is_guest) {
                            displayName = `${r.display_name}<br><span class='reservedBy'>${this.getUserName(
                                r.user
                                )}</span><br><span class='seat-id-display'>Seat ${label.code}</span>`;
                        } else {
                            displayName = `${r.display_name}<br><span class='seat-id-display'>Seat ${label.code}</span>`;
                        }
                    }
                    return {
                        id: label.code,
                        label: label.label,
                        reserved: !!r,
                        reservedBy: displayName,
                        reservation: r || null, // Also hold the reservation object
                    };
                });
            } catch (e) {
                console.error("Failed to fetch reservation information:", e);
            }
        },
        seatGridStyle(seat) {
    let seatId = typeof seat === 'string' ? seat : seat.id;
    const pos =
      (this.seatGridMap407 && this.seatGridMap407[seatId]) ||
      (this.seatGridMap305 && this.seatGridMap305[seatId]);
    if (!pos) return { display: 'none' };
    return {
        gridColumn: `${pos.c} / span ${pos.w}`,
        gridRow: `${pos.r} / span ${pos.h}`,
    };
},
        formatDateWithWeekday(dateStr) {
            if (!dateStr) return "";
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            const day = date.getDate();
            const weekday = date.toLocaleDateString("en-GB", { weekday: "short" });
            return `${day} ${weekday}`;
        },
        prevDay() {
            const d = new Date(this.selectedDate);
            d.setDate(d.getDate() - 1);
            const now = this.$now();
            const minDisplayDate = new Date(
                now.getFullYear(),
                now.getMonth() - 3,
                now.getDate()
            ); // 3 months ago
            if (d < minDisplayDate) {
                return; // Do nothing if out of bounds
            }
            this.selectedDate = d.toISOString().slice(0, 10);
            this.fetchReservations();
        },
        nextDay() {
            const d = new Date(this.selectedDate);
            d.setDate(d.getDate() + 1);
            const now = this.$now();
            const maxDisplayDate = new Date(
                now.getFullYear() + 1,
                now.getMonth(),
                now.getDate()
        ); // 1 year ahead

        if (d > maxDisplayDate) {
            return; // Do nothing if out of bounds
        }
        this.selectedDate = d.toISOString().slice(0, 10);
        this.fetchReservations();
    },

    openCancelModal(reservationId) {
        this.cancelReservationId = reservationId;
        this.showCancelModal = true;
    },
    onCancelConfirmed() {
        this.showCancelModal = false;
        this.fetchReservations();
    },
    handleSeatClick(seat) {
        const res = this.getReservation(seat.id);
        const now = this.$now();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const selectedDateObj = new Date(this.selectedDate);

        if (res && res.id != null) {
            // Check if res.id is not null
            if (res.user === this.currentUserId) {
                // If it's your own reservation, check if it's in the past
                if (selectedDateObj < today) {
                    return; // Do nothing if past reservation
                }
                this.openCancelModal(res.id);
            }
            return;
        }

        // Prevent making new reservations in the past
        if (selectedDateObj < today) {
            return; // Do nothing if in the past
        }

        this.selectedSeat = seat;
        this.showModal = true;
    },
    getReservation(seatId) {
        const seat = this.seats.find((s) => s.id === seatId);
        return seat && seat.reservation ? seat.reservation : null;
    },
    closeModal() {
        this.showModal = false;
        this.selectedSeat = null;
    },
    async afterConfirm() {
        this.closeModal();
        await this.fetchReservations();
    },
    // Get username from user ID
    getUserName(userId) {
        const user = this.users.find((u) => u.id === userId);
        return user ? user.username : `ID:${userId}`;
    },
    isPastDate(dateString) {
        const targetDate = new Date(dateString);
        const today = this.$now();
        today.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);
        return targetDate < today;
    },
},
};
</script>
<style>
    .reservedBy {
        font-size: 12px;
    }
    .seat-id-display {
        font-size: 12px;
        margin-top: 2px;
    }
</style>
<style scoped>
    .summaryData {
        display: flex;

        & > div {
            width: 150px;
            border: 1px solid var(--lightBlue);
            border-radius: 10px;
            text-align: center;
            margin-right: 1rem;
            & p {
                color: var(--blue);
                font-weight: 600;
                font-size: 14px;

                &:first-child {
                    margin: 0;
                    padding: 0.6rem 0;
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;
                    background: var(--lightBlue);
                }
            }
        }
    }
    .seatWrap {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 1rem;
        padding-top: 1rem;
    }
    .hubRoomLink{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    .remaining-seats {
        margin-top: 10px;
    }

    .monthNavWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1rem;
    }
    .dateNavWrap {
        & input {
            font-size: 1.5em;
            border: none;
            color: var(--blue);
            font-weight: 600;
        }
    }
    .monthNav {
        background: none;
        border: none;
        font-size: 14px;
        cursor: pointer;
        margin: 0 1rem;
        color: var(--blue);
    }
    .seatWrap.seatGrid {
        display: grid;
        grid-template-columns: repeat(var(--cols, 24), 1fr);
        grid-template-rows: repeat(var(--rows, 20), 1fr);
        gap: 6px;
        padding: 30px;
        min-height: 560px;  
        background: #f2f9ff;

        & .seat {
            width: auto;
            margin: 0;
            padding: 0;
            display: grid;
            place-items: center;
            border: 2px solid var(--blue);
            border-radius: 8px;
            color: var(--blue);
            background: white;
            text-align: center;
            cursor: pointer;
            word-break:break-word;
            &.reserved {
                background: var(--green);
                cursor: inherit;
                color: white;
                border: none;
            }
            &.past-date {
                background: #e0e0e0;
                cursor: inherit;
                color: #a0a0a0;
                border: 2px solid #a0a0a0;
            }
            &.reservedByYou {
                background: var(--grad);
                color: white;
                border: none;
            }
        }
    }
    .roomsFlex{ display:flex; flex-wrap:wrap; gap:16px; align-items:flex-start; }
    .roomBox{ flex:1 1 420px; min-width:300px; }
    .roomTitle{
        background: var(--blue);
        color: white;
        padding: 1rem;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .t305{
        .roomTitle{ background: var(--green);}
        .seatWrap.seatGrid {
            background: #f3feff;
            & .seat {
                color: var(--green);
                border-color:var(--green);
                &.reserved{
                    color: white;
                    &.past-date{
                        color: #a0a0a0;
                        border-color:#a0a0a0;
                    }
                }
                &.past-date{
                        color: #a0a0a0;
                        border-color:#a0a0a0;
                    }
            }
        }
    }
    @media (max-width:900px){ .roomBox{ flex-basis:100%; min-width:0; } }
    @media (max-width:768px){
        .seatWrap.seatGrid {
            padding: 10px;
        }
    }
</style>
